import React from "react";

// Icon dùng chung (đơn giản, theo phong cách stroke có sẵn).
const IconImage = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);
const IconAnalyze = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
);
const IconChecklist = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
  </svg>
);
const IconBook = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>
);
const IconCode = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
  </svg>
);
const IconBug = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 14v6m0-6a4 4 0 00-4 4m4-4a4 4 0 014 4m-9-6H3m18 0h-2M5 9l2 1m12-1l-2 1M12 4a4 4 0 014 4v2a4 4 0 01-8 0V8a4 4 0 014-4z" />
  </svg>
);
const IconSearch = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);
const IconDoc = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const IconChat = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
);

// Nội dung welcome theo từng nhóm chế độ.
const WELCOME_BY_GROUP = {
  general: {
    title: "Bạn cần trợ giúp gì?",
    sub: "Trò chuyện tự do — hỏi đáp, brainstorm, viết nội dung, tư vấn... không gắn môn học hay luyện thi.",
    suggestions: [
      {
        title: "Hỏi đáp nhanh",
        desc: "Giải thích khái niệm hoặc trả lời câu hỏi thường ngày",
        prompt: "Giải thích cho tôi một khái niệm tôi đang tò mò, bằng ngôn ngữ dễ hiểu, không cần format bài giải.",
        icon: IconChat,
      },
      {
        title: "Brainstorm ý tưởng",
        desc: "Gợi ý hướng đi cho dự án, bài viết hoặc kế hoạch",
        prompt: "Tôi đang cần brainstorm ý tưởng. Hãy hỏi tôi vài câu ngắn rồi đề xuất 5 hướng khả thi.",
        icon: IconAnalyze,
      },
      {
        title: "Viết / chỉnh sửa",
        desc: "Soạn email, caption, đoạn văn hoặc góp ý bản nháp",
        prompt: "Tôi sẽ mô tả nội dung cần viết. Hãy soạn bản nháp ngắn gọn, rõ ràng, và hỏi tôi nếu thiếu thông tin.",
        icon: IconDoc,
      },
      {
        title: "Tóm tắt nội dung",
        desc: "Rút gọn văn bản hoặc tài liệu dài",
        prompt: "Tôi sẽ dán một đoạn văn. Hãy tóm tắt ý chính bằng bullet point, giữ đúng tinh thần nội dung gốc.",
        icon: IconChecklist,
      },
    ],
  },
  math: {
    title: "Hôm nay bạn muốn học gì?",
    sub: "Hỏi bài tập mọi môn, phân tích đề, tạo lời giải chi tiết hoặc luyện thi cùng ChatBot PIMATH.",
    suggestions: [
      {
        title: "Giải bài từ ảnh",
        desc: "Chụp/tải ảnh đề (mọi môn) và nhận lời giải chi tiết",
        prompt: "Tôi có một bài tập. Hãy hướng dẫn tôi cách tải ảnh đề lên và giải/trả lời từng bước thật rõ ràng.",
        icon: IconImage,
      },
      {
        title: "Phân tích dạng bài",
        desc: "Nhận diện dạng câu hỏi và phương pháp làm",
        prompt: "Giúp tôi phân tích một dạng bài: các bước nhận diện, phương pháp làm và ví dụ minh họa.",
        icon: IconAnalyze,
      },
      {
        title: "Tạo đề luyện tập",
        desc: "Sinh bộ đề theo môn, chủ đề và mức độ",
        prompt: "Tạo cho tôi một đề luyện tập gồm 10 câu theo chủ đề tôi chọn, có đáp án và lời giải chi tiết.",
        icon: IconChecklist,
      },
      {
        title: "Tóm tắt kiến thức",
        desc: "Tổng hợp lý thuyết, công thức trọng tâm",
        prompt: "Tóm tắt cho tôi phần kiến thức trọng tâm của một chuyên đề, kèm công thức/ý chính và lưu ý khi làm bài.",
        icon: IconBook,
      },
    ],
  },
  programming: {
    title: "Hôm nay bạn muốn code gì?",
    sub: "Viết code, sửa lỗi, giải thích thuật toán hay review dự án — ChatBot PIMATH hỗ trợ bạn như một senior engineer.",
    suggestions: [
      {
        title: "Viết tính năng mới",
        desc: "Mô tả yêu cầu, nhận code và hướng dẫn triển khai",
        prompt: "Tôi muốn viết một tính năng mới. Hãy hỏi tôi về ngôn ngữ, framework rồi phân tích yêu cầu và viết code mẫu kèm cách test.",
        icon: IconCode,
      },
      {
        title: "Sửa lỗi / Debug",
        desc: "Dán lỗi hoặc code để tìm nguyên nhân và cách sửa",
        prompt: "Tôi đang gặp một lỗi trong code. Hãy hướng dẫn tôi cách mô tả lỗi, rồi phân tích nguyên nhân và đưa ra bản sửa.",
        icon: IconBug,
      },
      {
        title: "Giải thích thuật toán",
        desc: "Ý tưởng, độ phức tạp và code minh họa",
        prompt: "Giải thích cho tôi một thuật toán: ý tưởng, độ phức tạp thời gian/bộ nhớ và code minh họa kèm ví dụ chạy tay.",
        icon: IconAnalyze,
      },
      {
        title: "Review code",
        desc: "Góp ý readability, performance, bảo mật",
        prompt: "Tôi sẽ dán một đoạn code. Hãy review: lỗi nghiêm trọng trước, rồi readability, performance, security kèm ví dụ sửa cụ thể.",
        icon: IconChecklist,
      },
    ],
  },
  research: {
    title: "Hôm nay bạn muốn nghiên cứu gì?",
    sub: "Phân tích tài liệu, tổng hợp nguồn, xây dựng đề cương và viết học thuật cùng ChatBot PIMATH.",
    suggestions: [
      {
        title: "Phân tích tài liệu",
        desc: "Tóm tắt ý chính, phương pháp và kết quả",
        prompt: "Tôi sẽ cung cấp một bài báo/tài liệu. Hãy tóm tắt ý chính, xác định phương pháp, dữ liệu, kết quả và cách dùng trong nghiên cứu của tôi.",
        icon: IconDoc,
      },
      {
        title: "Xây dựng đề cương",
        desc: "Vấn đề, khoảng trống, câu hỏi, phương pháp",
        prompt: "Giúp tôi xây dựng đề cương nghiên cứu: vấn đề nghiên cứu, khoảng trống, câu hỏi, phương pháp và đóng góp dự kiến.",
        icon: IconChecklist,
      },
      {
        title: "Tổng hợp nguồn",
        desc: "Nhóm chủ đề và viết literature review",
        prompt: "Hướng dẫn tôi tổng hợp nhiều nguồn theo chủ đề/phương pháp, chỉ ra điểm chung, khác biệt, khoảng trống và viết thành đoạn literature review.",
        icon: IconSearch,
      },
      {
        title: "Phản biện bài viết",
        desc: "Góp ý lập luận và đề xuất viết lại",
        prompt: "Tôi sẽ dán một đoạn bài viết học thuật. Hãy nhận xét tổng quan, chỉ ra chỗ lập luận yếu/thiếu bằng chứng và đề xuất bản viết lại.",
        icon: IconAnalyze,
      },
    ],
  },
};

function WelcomeScreen({ onSelectSuggestion, modeGroup = "math" }) {
  const content = WELCOME_BY_GROUP[modeGroup] || WELCOME_BY_GROUP.math;

  return (
    <div className="pim-welcome-wrap">
      <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-red-600 to-red-700 flex items-center justify-center shadow-lg shadow-red-200/60">
        <span className="text-white text-3xl font-bold leading-none">π</span>
      </div>

      <h1 className="pim-welcome-title">{content.title}</h1>

      <p className="pim-welcome-sub">{content.sub}</p>

      <div className="pim-suggestion-grid">
        {content.suggestions.map((s) => (
          <button
            key={s.title}
            type="button"
            className="pim-suggestion-card"
            onClick={() => onSelectSuggestion?.(s.prompt)}
          >
            <div className="pim-suggestion-icon">{s.icon}</div>
            <div className="min-w-0">
              <div className="pim-suggestion-title">{s.title}</div>
              <div className="pim-suggestion-desc">{s.desc}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default WelcomeScreen;
